import { render, staticRenderFns } from "./UserListInfo.vue?vue&type=template&id=c0070602&"
import script from "./UserListInfo.vue?vue&type=script&lang=js&"
export * from "./UserListInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserListInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserListInfo.vue"
export default component.exports